// Module
var code = "<script id=\"wcc-components-translation-checkbox\" type=\"text/template\">\r\n    <icheck-item params=\"selected: isTranslationShown\">\r\n        <span data-bind=\"text: title\"></span>\r\n    </icheck-item>\r\n</script>";
// Exports
module.exports = code;